module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfCxc4EsA.d9600d97.woff2";